import { Box } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

export default function BackPageButton() {
  const navigate = useNavigate()

  const goToPreviousPage = () => {
    navigate(-1)
  }

  return <Box
        component='button'
        sx={[{ py: 1, pl: 2, pr: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'third.main', width: 'fit-content', borderRadius: '0.5rem', border: 'none' }, {
          '&:hover': {
            cursor: 'pointer',
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
          },
        }]}
        onClick={goToPreviousPage}
      >
        <ArrowBackIosIcon sx={{ color: 'third.contrastText' }}/>
  </Box>
}
